import { atom } from 'recoil'
import { IEnum } from '@/pages/MDM/mdm.types.ts'

interface IEnumsAtomState {
  items: IEnum[]
}

const enumsAtom = atom<IEnumsAtomState>({ key: 'mdm/enums', default: { items: [] } })
export default enumsAtom
